import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { IPortalPageSectionItem } from 'models/portal/page/portalpagesectionitem';
import { ISectionImageElement } from 'models/common/sectionimageelement';
import { ISectionTextElement } from 'models/common/sectiontextelement';
import { Link } from 'react-router';
import { formatCurrency, setProductPictureUrl } from 'helpers/common';
import { LikeButton } from 'components';
import { AuthConsumer } from 'containers';

const classNames = require('classnames');

export interface IProps {
	sectionItem: IPortalPageSectionItem;
	isLastItemInRow?: boolean;
	t?: (key: string) => string;
	isFollowing?: boolean;
	followItem?: () => void;
	unfollowItem?: () => void;
	goToCard?: (id: string, type?: any, target?: string) => void;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ViewSectionItemProduct extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);
		this.goToCard = this.goToCard.bind(this);
	}

	private goToCard(e: any, id, type) {
		e.preventDefault();
		if (this.props.goToCard) {
			this.props.goToCard(id, type);
		}
	}

	public render() {
		const { followItem, isFollowing, unfollowItem } = this.props;
		const { elements } = this.props.sectionItem;
		const buttonProps = {
			likeItem: followItem,
			unlikeItem: unfollowItem,
			isLiked: isFollowing,
		};

		const name = (elements[1] as ISectionTextElement).text;
		const originalPrice = parseFloat((elements[4] as ISectionTextElement).text);
		const price = parseFloat((elements[3] as ISectionTextElement).text);
		const shopCurrencyKey = parseInt((elements[5] as ISectionTextElement).text, 10);
		const id = (elements[7] as ISectionTextElement).text;

		const img = (
			<img {...setProductPictureUrl((elements[0] as ISectionImageElement).imageUrl, true)} className="image" />
		);
		const linkStyle = {
			backgroundImage: `url(${setProductPictureUrl((elements[0] as ISectionImageElement).imageUrl, true).src})`,
		};

		return (
			<AuthConsumer>
				{({ isAuthenticated, signinRedirect }) => (
					<div className="commonItemCard productItemCard portalPageProductItem">
						{followItem ? (
							<LikeButton {...buttonProps} isAuthenticated={isAuthenticated} signinRedirect={signinRedirect} />
						) : undefined}
						{elements[0].redirectUrl ? (
							<Link to={(elements[0] as ISectionImageElement).redirectUrl} className="imageHolder" style={linkStyle}>
								{img}
							</Link>
						) : (
							<a
								className="imageHolder"
								style={linkStyle}
								onClick={(e) => {
									this.goToCard(e, id, c.NODE_TYPE_PRODUCT);
								}}
							>
								{img}
							</a>
						)}
						<div className="itemDetail">
							<div className="shopName">
								{elements[1].redirectUrl ? (
									<Link to={(elements[1] as ISectionTextElement).redirectUrl}>
										{(elements[2] as ISectionTextElement).text}
									</Link>
								) : (
									<a>{(elements[2] as ISectionTextElement).text}</a>
								)}
							</div>
							{elements[0].redirectUrl ? (
								<div className="productName" title={name}>
									<Link to={(elements[0] as ISectionImageElement).redirectUrl}>{name}</Link>
								</div>
							) : (
								<div className="productName" title={name}>
									<a
										onClick={(e) => {
											this.goToCard(e, id, c.NODE_TYPE_PRODUCT);
										}}
									>
										{name}
									</a>
								</div>
							)}
							<div className="credit">
								{originalPrice > price ? (
									<span className="salePrice">{formatCurrency(shopCurrencyKey, originalPrice)}</span>
								) : null}
								<span className={classNames('amount', { ['discount']: originalPrice > price })}>
									{formatCurrency(shopCurrencyKey, price)}
								</span>
							</div>
						</div>
					</div>
				)}
			</AuthConsumer>
		);
	}
}

export { ViewSectionItemProduct };
